<template>
  <div v-if="auditDetail" :class="$style.headerContainer">
    <div class="columns">
      <div class="column" :class="$style.auditPageTopContainer">
        <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
          <ul>
            <li>
              <a :href="getProjectUrl">{{
                getFormattedTitle(auditDetail.project.title)
              }}</a>
            </li>
            <li class="is-active">
              <a href="#" aria-current="page">{{
                getFormattedTitle(auditSettingInfo.name)
              }}</a>
            </li>
          </ul>
        </nav>
        <div :class="$style.auditTitle">
          <b-tooltip
            v-if="auditSettingInfo.name.length > 50"
            :label="auditSettingInfo.name"
            multilined
            position="is-right"
            :class="$style.tooltipTitle"
          >
            {{ auditSettingInfo.name.substring(0, 50) + '...' }}
          </b-tooltip>
          <h1 v-else :class="$style.auditTitleHeader">
            {{ auditSettingInfo.name }}
          </h1>
        </div>
        <div class="columns" :class="$style.projectTitleContainer">
          <div>
            <b-icon :class="$style.headerRightIcon" icon="folder-outline">
            </b-icon>
            <span :class="$style.auditInfoSmallText">{{
              auditPageSubHeading
            }}</span>
          </div>
          <div v-if="auditSettingInfo.startDate && auditSettingInfo.endDate">
            <b-icon :class="$style.headerRightIcon" icon="calendar"> </b-icon>
            <span :class="$style.auditInfoSmallText">
              {{ formatDate(auditSettingInfo.startDate) }} -
              {{ formatDate(auditSettingInfo.endDate) }}
            </span>
          </div>
          <div v-else-if="auditSettingInfo.startDate">
            <b-icon :class="$style.headerRightIcon" icon="calendar"> </b-icon>
            <span :class="$style.auditInfoSmallText">
              {{ 'Starts From ' + formatDate(auditSettingInfo.startDate) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AuditDetail } from '@/store/modules/audits/types/audits.types';
import dayjs from 'dayjs';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '../../../utils/date.util';

@Component({})
export default class AuditHeader extends Vue {
  @Prop()
  public auditDetail!: AuditDetail;
  @Prop({ default: false })
  public dataCollectorRole!: boolean;
  @Prop()
  public auditSettingInfo!: string;

  public getFormattedTitle(title: string) {
    if (title.length > 45) {
      return title.substring(0, 45) + '...';
    } else {
      return title;
    }
  }

  get auditPageSubHeading() {
    if (this.auditDetail.auditCategory === 'Cycle') {
      return (
        this.auditDetail.auditCategory +
        ', Block ' +
        this.auditDetail.auditCycleNo
      );
    } else {
      return this.auditDetail.auditCategory;
    }
  }

  get getProjectUrl() {
    if (this.auditDetail) {
      let projectUrl =
        '/projects/' + this.auditDetail.project.id + '#dashboard';
      if (this.dataCollectorRole) {
        projectUrl = '/projects/' + this.auditDetail.project.id + '/homepage';
      }
      return projectUrl;
    }
    return '';
  }

  public formatDate(s: string) {
    return dayjs(s).format(DATE_TIME_FORMAT);
  }
}
</script>
<style lang="scss" module>
.headerContainer {
  padding: 8px 0px 2rem 0px;
}
.auditPageTopContainer {
  margin-top: 5px;
  padding-top: 8px;
  width: 100%;
}
.auditTitle {
  margin-bottom: 8px;
}
.projectTitleContainer {
  padding-top: 10px;
  padding-left: 19px;
  display: flex;
  justify-content: flex-start;
  div:first-child {
    margin-right: 27px;
  }
}
.headerRightIcon {
  padding-right: 15px;
  color: #00205b;
  font-size: 14px;
}
.headerRightText {
  color: #444f51;
}
.auditInfoSmallText {
  color: #444f51;
  font-size: 16px;
  text-transform: capitalize;
}
.auditInfoSmallText {
  color: #444f51;
  font-size: 16px;
  text-transform: capitalize;
}
.auditTitleHeader {
  color: #00205b;
  font-size: 40px;
  font-weight: 700;
  font-family: Oswald;
  width: 100%;
  display: inline flow-root;
  height: 35px;
  padding-top: 5px;
}
.tooltipTitle {
  font-family: Oswald;
  font-size: 40px;
  font-weight: 700;
  color: #00205b;
  &::after {
    font-family: 'Open Sans';
    word-break: break-all;
    margin-top: 15px;
  }
}
</style>
